import React from 'react';
import cn from 'classnames';
import { FeatureIcon } from '~/common/models';
import { toCssColor } from '~/common/utils';
import styles from './index.module.scss';

interface HeadingProps {
  heading: FeatureIcon;
  containerClassName?: string;
}

export const Heading = React.memo<HeadingProps>(
  ({ heading, containerClassName }) => {
    const [alignmentClass, setAlignmentClass] = React.useState<string>('');

    React.useEffect(() => {
      let aClass = cn(styles.heading, containerClassName, 'container');

      if (!!heading.alignment) {
        const alignments = heading.alignment.split('-');
        if (alignments?.length === 2) {
          aClass = cn(
            aClass,
            styles[`${alignments[0]}`],
            styles[`${alignments[1]}`]
          );
        }
      }

      setAlignmentClass(aClass);
    }, []);

    return (
      <div className={cn(styles.headingMain, styles[heading.mobileLayout])}>
        <div className={alignmentClass}>
          <div id="contentFeature-heading">
            <div
              data-field="headingText"
              className={styles.title}
              style={{ color: toCssColor(heading.fontColor) }}
              dangerouslySetInnerHTML={{ __html: heading.headingText }}
            />
            <div
              data-field="subHeadingText"
              className={styles.subHeading}
              style={{ color: toCssColor(heading.fontColor) }}
              dangerouslySetInnerHTML={{ __html: heading.subHeadingText }}
            />
          </div>
        </div>
      </div>
    );
  }
);
